import { z } from 'zod';

export const AssistantHandoffToolDestinationSchema = z.object({
  targetAssistantId: z.string().uuid(),
  description: z.string(),
});

export type AssistantHandoffToolDestination = z.infer<typeof AssistantHandoffToolDestinationSchema>;

export const AssistantHandoffToolMetadataSchema = z.object({
  destinations: z.array(AssistantHandoffToolDestinationSchema),
});

export type AssistantHandoffToolMetadata = z.infer<typeof AssistantHandoffToolMetadataSchema>;
